// Motion animations: cursor, reveals, magnetic effects

import { isTouch } from './utils.js';

export const initAnimations = async (motion) => {
  if (!motion) return false;

  const rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const touchDevice = isTouch();

  // На мобилке отключаем тяжелые анимации
  if (touchDevice) {
    return false;
  }

  const { animate, scroll, inView, stagger } = motion;

  // Progress bar on scroll
  scroll(p => {
    document.getElementById('progress').style.width = p * 100 + '%';
  });

  if (rm) {
    return false;
  }

  // HERO headline lines rise up
  animate(
    '.hero h1 .line span',
    { y: ['105%', '0%'] },
    {
      delay: stagger(0.12, { startDelay: 0.15 }),
      type: 'spring',
      stiffness: 90,
      damping: 16,
    }
  );

  animate(
    '.hero [data-fade]',
    { opacity: [0, 1], y: [20, 0] },
    { delay: 0.7, duration: 0.7 }
  );

  // MARQUEES: scroll-velocity driven base + constant drift
  function setupMarquee(el, dir) {
    let base = dir * 0.6, x = 0, w = el.scrollWidth / 2;
    let vel = 0, last = window.scrollY;
    scroll((p, info) => {});
    addEventListener(
      'scroll',
      () => {
        vel = window.scrollY - last;
        last = window.scrollY;
      },
      { passive: true }
    );
    function loop() {
      x += base + vel * 0.25 * dir;
      vel *= 0.9;
      if (x <= -w) x += w;
      if (x >= 0) x -= w;
      el.style.transform = `translateX(${x}px)`;
      requestAnimationFrame(loop);
    }
    loop();
  }

  const gmq = document.getElementById('gmq');
  if (gmq) {
    gmq.innerHTML += gmq.innerHTML;
    setupMarquee(gmq, 1);
  }

  // REVEALS on scroll
  document.querySelectorAll('.reveal').forEach(el => {
    inView(
      el,
      () => {
        animate(
          el,
          { opacity: [0, 1], y: [30, 0] },
          { duration: 0.8, ease: [0.16, 0.84, 0.36, 1] }
        );
      },
      { amount: 0.2 }
    );
  });

  // COUNT-UP animations
  document.querySelectorAll('[data-count]').forEach(el => {
    const t = +el.dataset.count, suf = el.dataset.suffix || '';
    el.style.display = 'inline-block';
    const finalHTML = t + (suf ? '<span class="suf">' + suf + '</span>' : '');
    el.innerHTML = finalHTML;
    el.style.minWidth = el.getBoundingClientRect().width + 'px';
    el.style.textAlign = 'left';
    el.innerHTML = '0';
    inView(
      el,
      () => {
        animate(0, t, {
          duration: 1.5,
          ease: [0.16, 0.84, 0.36, 1],
          onUpdate: v =>
            (el.innerHTML =
              Math.round(v) +
              (suf ? '<span class="suf">' + suf + '</span>' : '')),
        });
      },
      { amount: 0.6 }
    );
  });

  // MAGNETIC effect on hover
  document.querySelectorAll('[data-magnetic]').forEach(el => {
    el.addEventListener('mousemove', e => {
      const r = el.getBoundingClientRect();
      animate(
        el,
        {
          x: (e.clientX - r.left - r.width / 2) * 0.3,
          y: (e.clientY - r.top - r.height / 2) * 0.45,
        },
        { type: 'spring', stiffness: 300, damping: 20 }
      );
    });
    el.addEventListener('mouseleave', () =>
      animate(el, { x: 0, y: 0 }, { type: 'spring', stiffness: 200, damping: 14 })
    );
  });

  return true;
};
